export const SET_ACTIVE_ID = 'SET_ACTIVE_ID';
export const SET_IS_CONFIGURATION_LOADING = 'SET_IS_CONFIGURATION_LOADING';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';

export default {
  SET_ACTIVE_ID,
  SET_IS_CONFIGURATION_LOADING,
  SET_SEARCH_TEXT,
};
